export default {
      id: "color_nutrition-usage",
      viewBox: "0 0 66 69",
      url: __webpack_public_path__ + "sprite.svg#color_nutrition",
      toString: function () {
        return this.url;
      }
    }